<template>
    <div @keyup.esc="triggerCloseModal" tabindex="0" class="wrapper-modal-add-to-cold-stock">
        <div class="modal-body">
            <div class="modal-inner">
                <div class="content-modal">
                    <div class="header-container">
                        <h3>Add <span v-if="carrierId == 1">Simon IoT</span><span v-else-if="carrierId == 2">T-Mobile</span><span v-else-if="carrierId == 3">Vodafone</span> SIMs to cold stock</h3>
                        <i v-on:click="triggerCloseModal" class="fa fa-close"></i>
                    </div>
                    <div class="pre-validation-content">
                        <div v-if="hideListValidation == false" class="sims-inputs-box">
                            <div class="keyboard-input">
                                <p class="instruction">Scan the barcode of / or enter the SIM number you can find on the back of the SIM card</p>
                                <div class="add-sims-container">
                                    <div class="add-sims">
                                        <input type="text" id="coldStockSimsInput" v-on:keyup="enterSimFromInput" v-model="newSimNumber" autofocus placeholder="Enter your SIM number here.">
                                        <button class="btn-add" id="coldStockAddSimsBtn" v-on:click="enterSimFromBtn">Add SIMs</button>
                                    </div>
                                </div>
                            </div>
                            <div class="dnd-sims">
                                <div class="innersims">
                                    <img src="../../assets/img/upload-sims.png" alt="">
                                    <div class="dnd-text">
                                        <h3>Drag and drop list of SIM's or Browse</h3>
                                        <p>The file selected needs to be a CSV, XLS, XLSX or TXT file where the SIMs are seperated by commas.</p>
                                    </div>
                                    <b-button v-on:click="clickInputField" variant="primary" id="coldStockBrowseBtn">Browse</b-button>
                                    <input type="file" v-on:change="readSimFile" ref="importFile" name="listsSims" id="listsSims">
                                </div>
                            </div>
                        </div>
                        <div v-if="hideListValidation == false" class="uploaded-sims">
                            <div v-if="failedValidationList.length > 0" class="invalid-sims">
                                <div class="invalid-sims-list-header">
                                    <div class="left-side">
                                        <h3>Uploaded list issues ({{totalFailedSimsCount}}/{{totalSimsCount}})</h3>
                                        <h4>SIM cards that coundn't be processed from the uploaded list.</h4>
                                    </div>
                                    <div class="right-side">
                                        <i :class="['fa', failedValidationListExpanded ? 'fa-angle-down' : 'fa-angle-left']" @click="validationFaliedExpand()"></i>
                                    </div>
                                </div>
                                <div v-for="item of failedValidationList" :class="['invalid-sims-list', failedValidationListExpanded ? 'expanded' : '']">
                                    <h6 class="name">{{item.groupName}} ({{item.iccids.length}}/{{totalSimsCount}})</h6>
                                    <h6 class="desc">{{item.groupDescription}}</h6>
                                    <div class="list-of-sims">
                                        <div v-for="sim of item.iccids" class="sim"> <i class="fts-icon-sim"></i> {{sim}}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="passedValidationList" class="valid-sims">
                                <h3 class="valid-sims-header">Can be added to Cold Stock ({{passedValidationList.length}}/{{totalSimsCount}})</h3>
                                <div class="valid-sims-list">
                                    <div v-for="sim of passedValidationList" class="sim"><i class="fts-icon-sim"></i> {{sim}} <i @click="removeSimFromList(sim)" class="fa fa-close"></i> </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="hideListValidation" class="operators-validation">
                            <div v-if="validatedInUse > 0 || validatedFailed > 0" class="operators-validation-header-box">
                                <h3 class="operators-validation-header">
                                    SIMs failed validation ({{operatorValidatedListFailedCount}}/{{operatorValidatedList.length}})
                                </h3>
                                <button @click="removeWrongSimsFromOperatorsList()" class="btn btn-danger">Remove all invalid SIMs</button>
                            </div>
                            <div v-if="validatedInUse > 0 || validatedFailed > 0" class="operators-validation-list">
                                <div v-for="sim of operatorValidatedList" v-if="sim.validationStatus != 'true'" class="sim validation-failed">
                                    <i class="fts-icon-sim"></i>
                                    {{sim.iccid}}
                                    <i @click="removeSimFromOperatorsList(sim.iccid)" class="fa fa-close"></i>
                                    <div v-if="sim.message" class="sim-message">{{sim.message}}</div>
                                    <div v-else class="sim-message">Unknown validation error</div>
                                </div>
                            </div>

                            <h3 v-if="validatedSuccesfuly > 0" class="operators-validation-header">
                                SIMs passed validation ({{validatedSuccesfuly}}/{{operatorValidatedList.length}})
                            </h3>
                            <div v-if="validatedSuccesfuly > 0" class="operators-validation-list">
                                <div v-for="sim of operatorValidatedList" v-if="sim.validationStatus == 'true'" class="sim validation-passed">
                                    <i class="fts-icon-sim"></i>
                                    {{sim.iccid}}
                                    <i @click="removeSimFromOperatorsList(sim.iccid)" class="fa fa-close"></i>
                                    <div class="sim-message">{{sim.message}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="control-bar">
                    <div class="left-side">
                        <button v-on:click="triggerCloseModal" class="btn btn-light">Cancel</button>
                        <button class="btn btn-danger" @click="clearColdStock()">Clear</button>
                    </div>
                    <button v-if="operatorValidationRequired && operatorValidationPassed == false" v-on:click="validateSims()" id="coldStockValidateBtn" :disabled="(this.passedValidationList == false || this.loadingSims == true)" class="btn btn-success">Validate SIMs</button>
                    <button v-if="operatorValidationRequired && operatorValidationPassed" v-on:click="sendToColdstock()" id="coldStockValidateBtn" :disabled="((validatedSuccesfuly == 0 || validatedInUse != 0 || validatedFailed != 0) || this.loadingSims == true)" class="btn btn-success">Add to cold stock</button>
                    <button v-if="operatorValidationRequired == false" v-on:click="sendToColdstock()" id="coldStockValidateBtn" :disabled="(this.passedValidationList == false || this.loadingSims == true)" class="btn btn-success">Add to cold stock</button>
                </div>
                <div class="loading-sims" v-if="loadingSims">
                    <div class="loading-sims-inner">
                        <div class="sk-wave">
                            <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                        </div>

                        <div class="text">
                            {{loaderString}}...
                            <p v-if="loaderString == 'Validating SIMs'">{{counter}}/{{operatorValidatedList.length}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Axios from 'axios'
    import globalStore from "../../variables";
    import XLSX from 'xlsx';

    export default {
        name: "ColdStock",
        data () {
            return {
                statusShowed: [],
                newSimNumber: '',
                simList: [],
                // textErrorAddSim: '',
                operatorValidationRequired: false,
                operatorValidationPassed: false,
                loadingSims: false,
                validatedSuccesfuly: -1,
                validatedFailed: 0,
                validatedInUse: 0,
                operatorValidatedListFailedCount: 0,
                timeOutClold: '',
                wrongSims: [],
                stringButton: 'Validation',
                actionButton: 'validation',
                counter: 0,
                simListToCheck: [],
                skipFilter: false,
                loaderString: 'Checking SIMs',
                passedValidationList: false,
                passedValidationListExpanded: true,
                failedValidationList: [],
                failedValidationListExpanded: true,
                operatorValidatedList: [],
                hideListValidation: false,
                totalSimsCount: 0,
                totalFailedSimsCount: 0,
                simsAlreadyProcessed: []
            }
        },
        methods: {
            triggerCloseModal() {
                this.closeModal();
            },
            addSimToList: function (sim) {

                if (sim.indexOf(',') !== -1) {
                    var sims = sim.split(',');

                    for (var i = 0 ; i < sims.length ; i++) {
                        sims[i] = sims[i].replace(" ","")
                        this.addSimToList(sims[i]);
                    }
                } else if (sim.indexOf('f') !== -1 || sim.indexOf('F') !== -1) {
                    var sims = sim;

                    if (sims.indexOf('f') !== -1) {
                        this.addSimToList(sims.replace(/f/g, ''));
                    }

                    if (sims.indexOf('F') !== -1) {
                        this.addSimToList(sims.replace(/F/g, ''));
                    }
                } else if (sim.indexOf(' ') !== -1) {
                    var sims = sim.split(' ');

                    for (var i = 0 ; i < sims.length ; i++) {
                        sims[i] = sims[i].replace(" ","")
                        this.addSimToList(sims[i]);
                    }
                } else if ((sim.length >= 18)&&(sim.length <= 22)){
                    var checkDouble = 0;

                    for (var j = 0; j < this.simList.length; j++) {
                        if (this.simList[j]['iccid'] == sim) {
                            checkDouble++
                        }
                    }

                    if (checkDouble > 0) {
                        this.textErrorAddSim = 'This sim is on the list';

                        setTimeout(() => {
                            this.textErrorAddSim = ''
                        }, 3000)
                    } else {
                        var simStatus = {
                            validationStatus: 'none',
                            iccid: sim
                        }
                        this.simList.push(simStatus)

                        this.counter = 0;

                        this.validateColdStock();
                    }

                    this.newSimNumber = '';
                } else {
                    this.textErrorAddSim = "SIM numbers must be between 18 and 22 digits in length and may not contain letters or special characters.";
                    setTimeout(() => {this.textErrorAddSim = ''}, 3000)
                }
            },
            validateColdStock(sims) {
                if (sims.length == 0) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'List can not be empty',
                        text: 'You are trying to send list with no correct SIM number to check, please add correct SIMs.',
                        duration: 5000,
                    });
                    return false
                }
                let simsParsed = []
                if (this.simsAlreadyProcessed.length > 0) {
                    for (let sim of sims) {
                        if (this.simsAlreadyProcessed.indexOf(sim) == -1) {
                            this.simsAlreadyProcessed.push(sim)
                            simsParsed.push(sim)
                        }
                    }
                } else {
                    this.simsAlreadyProcessed = sims
                    simsParsed = sims
                }
                if (simsParsed.length == 0) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'List full of duplicates',
                        text: 'You are trying to send list with all SIMs already validated, please add correct SIMs.',
                        duration: 5000,
                    });
                    return false
                }
                this.loadingSims = true
                Axios.post(globalStore.data.restApiUrl + '/bulk/validation/cold-stock?companyId=' + this.companyId +'&carrierId=' + this.carrierId, simsParsed)
                    .then(response => {
                        // this.passedValidationList = false
                        // this.failedValidationList = []
                        for (let simsGroup of response.data.validationGroups) {
                            if (simsGroup.valid == true) {
                                if (this.passedValidationList == false) {
                                    this.passedValidationList = []
                                }
                                for (let sim of simsGroup.iccids) {
                                    this.passedValidationList.push(sim)
                                }
                            } else {
                                if (this.failedValidationList.length > 0) {
                                    let added = false
                                    for (let group of this.failedValidationList) {
                                        if (group.groupName == simsGroup.groupName) {
                                            for (let sim of simsGroup.iccids) {
                                                group.iccids.push(sim)
                                            }
                                            added = true
                                        }
                                    }
                                    if (added == false) {
                                        this.failedValidationList.push(simsGroup)
                                    }
                                } else {
                                    this.failedValidationList.push(simsGroup)
                                }
                            }
                        }

                        if (this.carrierId != 3) {
                            this.operatorValidationRequired = true
                        } else {
                            this.operatorValidationRequired = false
                        }

                        this.totalSimsCount = this.simsAlreadyProcessed.length
                        this.totalFailedSimsCount = this.simsAlreadyProcessed.length - (this.passedValidationList ? this.passedValidationList.length : 0)

                        this.loadingSims = false
                    })
                    .catch(error => {
                        this.loadingSims = false
                        console.log(error)
                    })
            },
            validationFaliedExpand() {
                this.failedValidationListExpanded = !this.failedValidationListExpanded
            },
            enterSimFromInput: function (ev) {
                ev.keyCode === 13 ? this.readDraggedList(this.newSimNumber) : null;
            },
            enterSimFromBtn: function () {
                this.readDraggedList(this.newSimNumber);
            },

            removeSimFromList (iccid) {
                for (let i = 0; i < this.passedValidationList.length; i++) {
                    if (this.passedValidationList[i] == iccid) {
                        this.passedValidationList.splice(i, 1);
                        if (this.passedValidationList.length == 0) {
                            this.passedValidationList = false
                        }
                        return false
                    }
                }
            },
            removeSimFromOperatorsList (iccid) {
                for (let i = 0; i < this.operatorValidatedList.length; i++) {
                    if (this.operatorValidatedList[i].iccid == iccid) {
                        if (this.operatorValidatedList[i].validationStatus == "true") {
                            this.validatedSuccesfuly--;
                        } else {
                            if (this.operatorValidatedList[i].message == "This SIM can\' be activated, this sim is in using") {
                                this.validatedInUse--;
                            } else {
                                this.validatedFailed--;
                            }
                        }
                        this.operatorValidatedList.splice(i,1)
                        if (this.operatorValidatedList.length == 0) {
                            this.hideListValidation = false
                            this.operatorValidationPassed = false
                            this.passedValidationList = false
                            this.failedValidationList = []
                        }
                        return false
                    }
                }
            },
            removeWrongSimsFromOperatorsList() {
                for (let i = this.operatorValidatedList.length - 1; i >= 0; i--) {
                    if (this.operatorValidatedList[i].validationStatus != 'true') {
                        if (this.operatorValidatedList[i].message == "This SIM can\' be activated, this sim is in using") {
                            this.validatedInUse--;
                        } else {
                            this.validatedFailed--;
                        }
                        this.operatorValidatedList.splice(i,1)
                    }
                }

                if (this.operatorValidatedList.length == 0) {
                    this.hideListValidation = false
                    this.operatorValidationPassed = false
                    this.passedValidationList = false
                    this.failedValidationList = []
                }
            },
            checkOperatorsSims() {
                console.log(this.validatedSuccesfuly)
                console.log(this.validatedInUse)
                console.log(this.validatedFailed)
                let correct = 0
                for (let sim of this.operatorValidatedList) {
                    if (sim.validationStatus == 'true') {
                        correct++
                    }
                }
                if (correct == this.operatorValidatedList.length) {
                    return false
                } else {
                    return true
                }
            },
            readSimFile: function (ev) {
                // this.simList = []
                // this.wrongSims = []
                // this.counter = 0
                if (ev.target) {
                    var f = ev.target.files[0];
                } else {
                    var f = ev[0];
                }

                var ext = f.name.slice(f.name.lastIndexOf("."));

                if (ext === ".csv") {

                    var ret = [];
                    var r = new FileReader();
                    var tempThis = this;
                    r.onload = (e) => {
                        var ct = r.result;
                        var words;

                        ct.indexOf("\n") > -1 ? words = ct.split("\n") : null;

                        if (typeof(words) == 'object') {
                            let tempArr = [];

                            for (let i = 0; i < words.length; i++) {
                                if (words[i].indexOf(",") > -1) {
                                    let temptempArr = words[i].split(",");
                                    for (let item in temptempArr) {
                                        if (temptempArr[item].length > 0) {
                                            tempArr.push(temptempArr[item])
                                        }
                                    }
                                } else {
                                    tempArr.push(words[i]);
                                }
                            }

                            words = tempArr
                        } else {
                            (ct.indexOf(",") > -1) ? words = ct.split(",") : null;
                        }

                        var len = words.length;

                        for (let i = 0 ; i < len ; i++){
                            words[i] = words[i].replace(/\D/g,'');
                            words[i] != ""  ? ret.push(words[i]) : null;
                        }
                        this.validateColdStock(ret);
                    }
                    r.readAsText(f);
                    this.$refs.importFile.value = null
                } else if (ext === '.txt') {

                    var ret = [];
                    if (ev.target) {
                        var f = ev.target.files[0];
                    } else {
                        var f = ev[0];
                    }

                    if (f) {
                        var r = new FileReader();
                        var tempThis = this;
                        r.onload = function(e) {
                            var ct = r.result;

                            ct.indexOf("\n") > -1 ? ct = ct.split("\n") : null;

                            if (typeof(ct) == 'object') {
                                let tempArr = [];

                                for (let i = 0; i < ct.length; i++) {
                                    if (ct[i].indexOf(",") > -1) {
                                        let temptempArr = ct[i].split(",");
                                        for (let item in temptempArr) {
                                            if (temptempArr[item].length > 0) {
                                                tempArr.push(temptempArr[item])
                                            }
                                        }
                                    } else {
                                        tempArr.push(ct[i]);
                                    }
                                }

                                ct = tempArr
                            } else {
                                ct.indexOf(",") > -1 ? ct = ct.split(",") : null;
                            }

                            if (typeof ct != 'string') {
                                var len = ct.length;
                                for (var i = 0 ; i < len ; i++) {
                                    ct[i] = ct[i].replace(/\D/g,'');
                                }
                            }
                            tempThis.validateColdStock(ct);
                        }
                        r.readAsText(f);
                        this.$refs.importFile.value = null
                    } else {
                        alert("Failed to load file");
                    }
                } else if ( ext== '.xls' || ext === ".xlsx" ) {
                    var tempThis = this;

                    let formData = new FormData();
                    formData.append('file', f);
                    Axios.post(`${globalStore.data.restApiUrl}/sims/parse/xlsx`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
                        .then(response => {
                            let simsNumber = response.data

                            if (simsNumber.length > 0) {
                                this.validateColdStock(simsNumber);
                            } else {
                                this.$notify({
                                    type: 'warn',
                                    group: 'notification',
                                    title: 'File is empty',
                                    text: 'The file what you upload is empty, please upload right file',
                                    duration: 3000,
                                });
                            }
                            this.$refs.importFile.value = null
                        })
                        .catch(error => {
                            this.loadingSims = false
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'File is wrong',
                                text: 'The file what you upload is wrong, please upload right file',
                                duration: 3000,
                            });
                            console.log(error)
                        })
                }
            },
            ProcessExcel(data) {
                var workbook = XLSX.read(data, {
                    type: 'binary'
                });

                var firstSheet = workbook.SheetNames[0];

                var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);

                let tempArray = [];

                for(let i = 0 ; i < excelRows.length ; i++){
                    tempArray.push(String(excelRows[i][Object.keys(excelRows[i])[0]]));
                }
                this.displaySim(tempArray);
            },
            clickInputField: function (ev) {
                ev.preventDefault();

                document.querySelector("#listsSims").click();
            },
            displaySim: function(numbers) {
                this.loadingSims = true;
                var invalid = "", arrTempRightSim = [];

                if (typeof numbers != 'string') {
                    for (var i = 0; i < numbers.length; i++) {
                        if ((numbers[i].length >= 18) && (numbers[i].length <= 22)) {
                            var newSim = {
                                iccid: numbers[i],
                                validationStatus: 'none'
                            }
                            this.simList.push(newSim)
                        } else {
                            invalid += ' ' + numbers[i] + ',';
                        }
                    }
                } else {
                    if ((numbers.length >= 18) && (numbers.length <= 22)) {
                        var newSim = {
                            iccid: numbers,
                            validationStatus: 'none'
                        }
                        this.simList.push(newSim)
                    } else {
                        invalid += ' ' + numbers + ',';
                    }
                }
            },
            validateSims() {
                this.loadingSims = true;
                this.loaderString = 'Validating SIMs'
                this.validatedSuccesfuly = 0;
                this.validatedFailed = 0;
                this.counter = 0;
                this.operatorValidatedList = []

                let simsToCheck = []
                for (let sim of this.passedValidationList) {
                    simsToCheck.push(sim);
                    let template = {
                        iccid: sim,
                        validationStatus: null,
                        message: null
                    }
                    this.operatorValidatedList.push(template)
                }

                Axios.post(`${globalStore.data.restApiUrl}/subscriber/sim-eligibility?carrierId=${this.carrierId}&allResults=true&companyId=${this.companyId}`, {iccids: simsToCheck})
                    .then(response => {
                        if (response.status == 200) {
                            this.statusShowed = [];
                            this.checkTransactionStatus(response.data.transactionId)
                        }
                    }).catch(error => {
                    this.loadingSims = false;
                    var errorResponse = error;
                    console.log(error)
                })
            },
            checkTransactionStatus(transactionID) {
                Axios.get(`${globalStore.data.restApiUrl}/transactions-new/${transactionID}?companyId=${this.companyId}&allResults=true`)
                    .then(response => {
                        if (response.status == 200) {

                            let transactionSims = response.data.transactionSims,
                                counterQueed = 0;

                            transactionSims.map(transaction => {
                                if (this.statusShowed.indexOf(transaction['iccid']) == -1) {
                                    if (transaction['transactionStatus'] == 'Success' && transaction['activationEligible'] == 'true' && transaction['simEligiblityStatus'] == 'AVAILABLE') {
                                        if (transaction['wfcEligible'] == 'true') {

                                            this.operatorValidatedList.map(sim => {
                                                if (sim.iccid == transaction['iccid']) {
                                                    if (sim.validationStatus != 'true') {
                                                        this.counter++;
                                                    }
                                                    sim.validationStatus = 'true'
                                                    sim.message = 'SIM is ready to add to Cold Stock'
                                                    if (transaction.subscriptionId) {
                                                        sim.subscriptionId = transaction.subscriptionId.replaceAll('"', '')
                                                    }
                                                    if (transaction.productOffer) {
                                                        sim.productOffer = transaction.productOffer
                                                    }
                                                }
                                            })
                                            this.statusShowed.push(transaction['iccid'])
                                        } else {

                                            this.operatorValidatedList.map(sim => {
                                                if (sim.iccid == transaction['iccid']) {
                                                    let checkIndex = this.wrongSims.findIndex( x => x.iccid ==  sim.iccid)

                                                    if (checkIndex == -1) {
                                                        let wrongSimItem = {
                                                            validationStatus: 'false',
                                                            iccid: sim.iccid,
                                                            message: 'This sim is disalowed to activation'
                                                        }
                                                        this.wrongSims.push(wrongSimItem)
                                                    }
                                                    if (sim.validationStatus != 'false') {
                                                        this.counter++;
                                                    }
                                                    sim.validationStatus = 'false'
                                                    sim.message = 'This sim is disalowed to activation'
                                                }
                                            })
                                            this.statusShowed.push(transaction['iccid'])
                                        }
                                    } else if (transaction['simEligiblityStatus'] == 'AVAILABLE_ON_TARGET') {
                                        this.operatorValidatedList.map(sim => {
                                            if (sim.iccid == transaction['iccid']) {
                                                if (sim.validationStatus != 'true') {
                                                    this.counter++;
                                                }
                                                sim.validationStatus = 'true'
                                                sim.message = 'SIM is ready to add to Cold Stock'
                                                sim.availableOnTarget = true
                                                if (transaction.subscriptionId) {
                                                    sim.subscriptionId = transaction.subscriptionId.replaceAll('"', '')
                                                }
                                                if (transaction.productOffer) {
                                                    sim.productOffer = transaction.productOffer
                                                }
                                            }
                                        })
                                        this.statusShowed.push(transaction['iccid'])
                                        counterQueed++
                                    } else if (transaction['transactionStatus'] == 'Queued') {
                                        counterQueed++
                                    } else if (transaction['transactionStatus'] == 'Error') {
                                        var messages = JSON.parse(transaction['message']);

                                        if (messages.hasOwnProperty('error')) {
                                            var messages = messages.error;

                                            if (messages.hasOwnProperty('code')) {

                                                this.operatorValidatedList.map(sim => {
                                                    if (sim.iccid == transaction['iccid']) {
                                                        let checkIndex = this.wrongSims.findIndex( x => x.iccid ==  sim.iccid)
                                                        if (checkIndex == -1) {
                                                            let wrongSimItem = {
                                                                validationStatus: 'false',
                                                                iccid: sim.iccid,
                                                                message: messages['userMessage'] + '<br/>Error code: ' + messages['code']
                                                            }
                                                            this.wrongSims.push(wrongSimItem)
                                                        }

                                                        sim.validationStatus = 'false'
                                                        sim.message = messages['userMessage'] + '<br/>Error code: ' + messages['code']
                                                    }
                                                })
                                                this.statusShowed.push(transaction['iccid'])
                                            } else {
                                                messages.map(item => {

                                                    this.operatorValidatedList.map(sim => {
                                                        if (sim.iccid == transaction['iccid']) {
                                                            let checkIndex = this.wrongSims.findIndex( x => x.iccid ==  sim.iccid)
                                                            if (checkIndex == -1) {
                                                                let wrongSimItem = {
                                                                    validationStatus: 'false',
                                                                    iccid: sim.iccid,
                                                                    message: item['userMessage'] + '<br/>Error code: ' + item['code']
                                                                }
                                                                this.wrongSims.push(wrongSimItem)
                                                            }
                                                            if (sim.validationStatus != 'false') {
                                                                this.counter++;
                                                            }
                                                            sim.validationStatus = 'false'
                                                            sim.message = item['userMessage'] + '<br/>Error code: ' + item['code']
                                                        }
                                                    })
                                                })
                                                this.statusShowed.push(transaction['iccid'])
                                            }
                                        } else {
                                            this.operatorValidatedList.map(sim => {
                                                if (sim.iccid == transaction['iccid']) {
                                                    let checkIndex = this.wrongSims.findIndex( x => x.iccid ==  sim.iccid)

                                                    if (checkIndex == -1) {
                                                        let wrongSimItem = {
                                                            validationStatus: 'false',
                                                            iccid: sim.iccid,
                                                            message: 'The SIM you have entered appears to be invalid, please check this SIM number and try again.\nError code: ' + messages.code
                                                        }
                                                        this.wrongSims.push(wrongSimItem)
                                                    }
                                                    if (sim.validationStatus != 'false') {
                                                        this.counter++;
                                                    }
                                                    sim.validationStatus = 'false'
                                                    sim.message = 'The SIM you have entered appears to be invalid, please check this SIM number and try again.\nError code: ' + messages.code
                                                }
                                            })
                                        }
                                    } else if (transaction['simEligiblityStatus'] == 'INUSE' || transaction['simEligiblityStatus'] == 'AGING') {
                                        this.operatorValidatedList.map(sim => {
                                            if (sim.iccid == transaction['iccid']) {
                                                let checkIndex = this.wrongSims.findIndex( x => x.iccid ==  sim.iccid)
                                                if (checkIndex == -1) {
                                                    let wrongSimItem = {
                                                        validationStatus: 'false',
                                                        iccid: sim.iccid,
                                                        message: 'This SIM can\'t be activated, this sim is in using.'
                                                    }
                                                    this.wrongSims.push(wrongSimItem)
                                                }
                                                if (sim.validationStatus != 'false') {
                                                    this.counter++;
                                                }
                                                sim.validationStatus = 'false'
                                                sim.message = 'This SIM can\'t be activated, this sim is in using.'
                                            }
                                        })
                                    }
                                }
                            })

                            if (counterQueed == 0) {
                                this.validateFinished();
                                this.loadingSims = false;
                            } else {
                                setTimeout(() => {
                                    this.checkTransactionStatus(transactionID)
                                }, 5000)
                            }
                        }
                    })
                    .catch(error => {
                        this.loadingSims = false
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Cold Stock SIMs not addedd',
                            text: 'Something went wrong during adding SIMs to cold stock, please contact support or try again later.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            validateFinished() {
                this.operatorValidationPassed = true
                this.hideListValidation = true
                this.validatedSuccesfuly = 0; //
                this.validatedInUse = 0;
                this.validatedFailed = 0;

                for (let i = 0 ; i < this.operatorValidatedList.length ; i++) {
                    if (this.operatorValidatedList[i].validationStatus == "true") {
                        this.validatedSuccesfuly++;
                    } else {
                        if (this.operatorValidatedList[i].message == "This SIM can't be activated, this sim is in using") {
                            this.validatedInUse++;
                        } else {
                            this.validatedFailed++;
                        }
                    }
                }

                this.operatorValidatedListFailedCount = this.validatedFailed + this.validatedInUse

                if (this.validatedSuccesfuly == this.operatorValidatedList.length) {
                    this.stringButton = 'Add to Cold Stock'
                    this.actionButton = 'add'
                }

                if  (this.validatedFailed) {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs validated fail',
                        text: this.validatedFailed + '/' + this.operatorValidatedList.length + ' SIMs invalid.',
                        duration: 3000,
                    });
                }

                if (this.validatedInUse) {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'SIMs in use',
                        text: this.validatedInUse + '/' + this.operatorValidatedList.length + ' SIMs already in use.',
                        duration: 3000,
                    });
                }

                this.$notify({
                    type: 'success',
                    group: 'notification',
                    title: 'SIMs validated succes',
                    text: this.validatedSuccesfuly + '/' + this.operatorValidatedList.length + ' SIMs validated.',
                    duration: 3000,
                });

            },
            clearColdStock() {
                this.simList = []
                this.wrongSims = []
                this.failedValidationList = []
                this.passedValidationList = false
                this.counter = 0
                this.operatorValidatedList = []
                this.validatedSuccesfuly = -1
                this.validatedFailed = 0
                this.validatedInUse = 0
                this.hideListValidation = false
                this.operatorValidationPassed = false
                this.simsAlreadyProcessed = []
            },
            sendToColdstock() {
                this.loaderString = 'Adding SIMs'

                if (this.carrierId == 1 || this.carrierId == 2) {

                    let array = [];
                    for (let sim of this.operatorValidatedList) {
                        array.push(sim.iccid);
                    }

                    let dataToSend = '';

                    if (this.addToCompany == true) {
                        dataToSend = {
                            iccids: array,
                            carrierId: this.carrierId
                        }
                    } else {
                        dataToSend = {
                            iccids: array,
                            orderId: Number(this.$route.params.id),
                            carrierId: this.carrierId
                        }
                    }


                    Axios.post(`${globalStore.data.restApiUrl}/cold-stock/bulk-assign?companyId=${this.companyId}`, dataToSend)
                        .then(response => {
                            if (response.status == 204) {
                                if (this.addToCompany == false) {
                                    this.$emit('validated', dataToSend.iccids.length);
                                    this.triggerCloseModal();
                                } else {
                                    this.$notify({
                                        type: 'success',
                                        group: 'notification',
                                        title: 'Cold Stock SIMs addedd',
                                        text: dataToSend.iccids.length + ' SIMs added to Cold Stock',
                                        duration: 5000,
                                    });
                                    this.triggerCloseModal();
                                }
                            }
                        })
                } else if (this.carrierId == 3) {
                    let iccids = [];
                    for (let sim of this.passedValidationList) {
                        iccids.push(sim)
                    }
                    let parsedData = {
                        iccids: iccids
                    }
                    Axios.post(`${globalStore.data.restApiUrl}/vodafone-assign?companyId=${this.companyId}`, parsedData)
                        .then(response => {
                            this.loadingSims = false;
                            if (response.status == 200) {
                                this.$emit('validated', this.passedValidationList.length);
                                this.triggerCloseModal();
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Cold Stock SIMs addedd',
                                    text: parsedData.iccids.length + ' SIMs added to Cold Stock',
                                    duration: 5000,
                                });
                            }
                        })
                        .catch(error => {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Cold Stock SIMs not addedd',
                                text: 'Something went wrong during adding SIMs to cold stock, please contact support or try again later.',
                                duration: 5000,
                            });
                            console.log(error)
                            this.loadingSims = false;
                        })
                } else if (this.carrierId == 4) {
                    let array = [];
                    let koreArray = [];
                    let availableOnTargetArray = []
                    for (let sim of this.operatorValidatedList) {
                        array.push(sim.iccid);
                    }
                    for (let sim of this.operatorValidatedList) {
                        if (sim.availableOnTarget) {
                            availableOnTargetArray.push({
                                iccid: sim.iccid,
                                subscriptionId: sim.subscriptionId.replaceAll('"', ''),
                                productOffer: sim.productOffer
                            })
                        } else {
                            koreArray.push({
                                iccid: sim.iccid,
                                subscriptionId: sim.subscriptionId.replaceAll('"', ''),
                                productOffer: sim.productOffer
                            });
                        }
                    }
                    if (koreArray.length) {
                        let dataToSend = {
                            koreSimMapping: koreArray,
                            iccids: array,
                            carrierId: this.carrierId
                        };

                        if (this.addToCompany != true) {
                            dataToSend.orderId = Number(this.$route.params.id)
                        }
                        Axios.post(`${globalStore.data.restApiUrl}/cold-stock/transfer-sims?companyId=${this.companyId}`, koreArray)
                            .then(response => {
                                if (availableOnTargetArray.length) {
                                    dataToSend.koreSimMapping = koreArray.concat(availableOnTargetArray)
                                }
                                this.checkKoreTransaction(response.data.transactionId, dataToSend)
                            })
                            .catch(error => {
                                this.loadingSims = false
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Cold Stock SIMs not addedd',
                                    text: 'Something went wrong during adding SIMs to cold stock, please contact support or try again later.',
                                    duration: 5000,
                                });
                                console.log(error)
                            })
                    } else {
                        let dataToSend = {
                            koreSimMapping: availableOnTargetArray,
                            iccids: array,
                            carrierId: this.carrierId
                        };

                        if (this.addToCompany != true) {
                            dataToSend.orderId = Number(this.$route.params.id)
                        }
                        Axios.post(`${globalStore.data.restApiUrl}/cold-stock/bulk-assign?companyId=${this.companyId}`, dataToSend)
                            .then(response => {
                                if (response.status == 204) {
                                    this.loadingSims = false
                                    if (this.addToCompany == false) {
                                        this.$emit('validated', dataToSend.iccids.length);
                                        this.triggerCloseModal();
                                    } else {
                                        this.$notify({
                                            type: 'success',
                                            group: 'notification',
                                            title: 'Cold Stock SIMs addedd',
                                            text: dataToSend.iccids.length + ' SIMs added to Cold Stock',
                                            duration: 5000,
                                        });
                                        this.triggerCloseModal();
                                    }
                                }
                            })
                            .catch(error => {
                                this.loadingSims = false
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Cold Stock SIMs not addedd',
                                    text: 'Something went wrong during adding SIMs to cold stock, please contact support or try again later.',
                                    duration: 5000,
                                });
                                console.log(error)
                            })
                    }
                }
            },
            checkKoreTransaction(transactionId, dataToSend) {
                this.loadingSims = true
                Axios.get(`${globalStore.data.restApiUrl}/transactions-new/${transactionId}?companyId=${this.companyId}&allResults=true`)
                    .then (response => {
                        if (response.data.transactionStatus == 'Completed' || response.data.transactionStatus == 'Success') {
                            Axios.post(`${globalStore.data.restApiUrl}/cold-stock/bulk-assign?companyId=${this.companyId}`, dataToSend)
                                .then(response => {
                                    if (response.status == 204) {
                                        this.loadingSims = false
                                        if (this.addToCompany == false) {
                                            this.$emit('validated', dataToSend.iccids.length);
                                            this.triggerCloseModal();
                                        } else {
                                            this.$notify({
                                                type: 'success',
                                                group: 'notification',
                                                title: 'Cold Stock SIMs addedd',
                                                text: dataToSend.iccids.length + ' SIMs added to Cold Stock',
                                                duration: 5000,
                                            });
                                            this.triggerCloseModal();
                                        }
                                    }
                                })
                                .catch(error => {
                                    this.loadingSims = false
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'Cold Stock SIMs not addedd',
                                        text: 'Something went wrong during adding SIMs to cold stock, please contact support or try again later.',
                                        duration: 5000,
                                    });
                                    console.log(error)
                                })
                        } else if (response.data.transactionStatus == 'Error' || response.data.transactionStatus == 'Failure') {
                            this.loadingSims = false
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Cold Stock SIMs not addedd',
                                text: 'An error occured during SIM transfer to cold stock, please contact support or try again later.',
                                duration: 5000,
                            });
                        } else {
                            setTimeout(() => {
                                this.checkKoreTransaction(transactionId, dataToSend)
                            }, 5000)
                        }
                    })
            },
            readDraggedList(simList) {
                var words;
                var ret = [];

                simList.indexOf("\n") > -1 ? words = simList.split("\n") : null;
                if (typeof(words) == 'object') {
                    let tempArr = [];

                    for (let i = 0; i < words.length; i++) {
                        if (words[i].indexOf(",") > -1) {
                            let temptempArr = words[i].split(",");
                            for (let item in temptempArr) {
                                if (item.indexOf('f') !== -1) {
                                    item = item.replace(/f/g, '');
                                }

                                if (item.indexOf('F') !== -1) {
                                    item = item.replace(/F/g, '');
                                }

                                if (temptempArr[item].length > 0) {
                                    if (typeof this.passedValidationList != 'boolean') {
                                        if (this.passedValidationList.indexOf(temptempArr[item]) == -1) {
                                            tempArr.push(temptempArr[item])
                                        }
                                    } else {
                                        tempArr.push(temptempArr[item])
                                    }
                                }
                            }
                        } else {
                            if (words[i].indexOf('f') !== -1) {
                                words[i] = words[i].replace(/f/g, '');
                            }

                            if (words[i].indexOf('F') !== -1) {
                                words[i] = words[i].replace(/F/g, '');
                            }

                            if (typeof this.passedValidationList != 'boolean') {
                                if (this.passedValidationList.indexOf(words[i]) == -1) {
                                    tempArr.push(words[i]);
                                }
                            } else {
                                tempArr.push(words[i]);
                            }
                        }
                    }

                    words = tempArr
                } else {
                    simList.indexOf(",") > -1 ? words = simList.split(",") : null;
                    if (words == undefined) {
                        simList.indexOf(" ") > -1 ? words = simList.split(" ") : null;
                    }
                    if (words == undefined) {
                        words = [simList]
                    }
                    if (typeof this.passedValidationList != 'boolean') {
                        words = words.filter((value) => {
                            if (value.indexOf('f') !== -1) {
                                value = value.replace(/f/g, '');
                            }

                            if (value.indexOf('F') !== -1) {
                                value = value.replace(/F/g, '');
                            }

                            if (value.indexOf(' ') !== -1) {
                                value = value.replace(/ /g, '');
                            }

                            return (this.passedValidationList.indexOf(value) == -1)
                        })
                    }
                }

                var len = words.length;

                for (let i = 0 ; i < len ; i++){
                    words[i] = words[i].replace(/\D/g,'');
                    words[i] != ""  ? ret.push(words[i]) : null;
                }
                if (ret.length > 0) {
                    this.validateColdStock(ret);
                }
                this.newSimNumber = ''
            }
        },
        props: {
            closeModal: '',
            companyId: '',
            orderData: '',
            carrierId: '',
            addToCompany: ''
        },
        mounted() {
            var self = this;
            if (this.$session.get('selectedSims')) {
                this.checkSimsInSession();
            }

            if (this.carrierId != 3) {
                this.operatorValidationRequired = true
            } else {
                this.operatorValidationRequired = false
            }

            document.addEventListener("dragenter", function (e) {
                e.preventDefault();

                if (document.querySelector(".dnd-sims") && !document.querySelector(".dnd-sims").classList.contains("dragged-fiel")) {
                    document.querySelector(".dnd-sims").classList.add('dragged-fiel');
                }

                e.dataTransfer.setData("text/plain", e.target.id);
                e.dataTransfer.setData("text", e.target.id);
            });

            document.addEventListener("dragleave", function (e) {
                e.preventDefault();

                if (document.querySelector(".dnd-sims") && !document.querySelector(".dnd-sims").classList.contains("dragged-fiel")) {
                    document.querySelector(".dnd-sims").classList.add('dragged-fiel');
                }
            });

            document.addEventListener("dragover", function (e) {
                e.preventDefault();
            });

            let dndArea = document.querySelector(".dnd-sims")

            dndArea.addEventListener("drop", function (e) {
                e.preventDefault();

                if (document.querySelector(".dnd-sims") && document.querySelector(".dnd-sims").classList.contains("dragged-fiel")) {
                    document.querySelector(".dnd-sims").classList.remove('dragged-fiel');
                }

                var files = e.dataTransfer.files;

                //this.uploadFile(files);
                if (files.length > 0) {
                    self.readSimFile(files);
                } else if (e.dataTransfer.getData("text").length > 0) {
                    self.readDraggedList(e.dataTransfer.getData("text"))
                } else {
                    self.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Wrong item dropped',
                        text: 'Item you dropped has not been recognized as a file or a list.',
                        duration: 5000,
                    })
                }
            });

            document.addEventListener("drop", function (e) {
                e.preventDefault();

                if (document.querySelector(".dnd-area") && document.querySelector(".dnd-area").classList.contains("dragged-fiel")) {
                    document.querySelector(".dnd-area").classList.remove('dragged-fiel');
                }
            });
        }
    }
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />

<style lang="scss" scoped>

    // custom scroll
    /* width */
    ::-webkit-scrollbar {
        width: 6px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #c9cfd4;
        border-radius: 3px;
        margin-right: 3px;
    }

    .wrapper-modal-add-to-cold-stock {
        position: fixed;
        width: 100vw;
        height: 100vh;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(44, 44, 44, 0.9);
        z-index: 3030;

        &.wrapper-disable {
            display: none;
        }
        .modal-body {
            width: 100vw;
            height: 100vh;
            padding: 1.5vh 1.5vw;
            display: flex;
            flex-direction: column;
            .modal-inner {
                position: relative;
                flex-grow: 1;
                border-radius: 5px;
                border: 1px solid #C9CFD4;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                overflow: hidden;
                background-color: #FFFFFF;


                .loading-sims {
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;

                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    background-color: rgba(255, 255, 255, 0.7);

                    .sk-wave {
                        margin: 0 auto 20px;
                        height: 60px;
                        .sk-rect {
                            width: 3px;
                            background-color: #39c354;
                            border-radius: 4px;
                        }
                    }

                    .text {
                        text-align: center;
                        font-size: 15px;
                        font-weight: 700;
                    }
                }

                .content-modal {
                    position: relative;
                    width: 100%;
                    flex-grow: 1;

                    .header-container {
                        display: flex;
                        justify-content: space-between;
                        padding: 20px;

                        h3 {
                            margin: 0;
                            font-size: 15px;
                        }
                        .fa-close {
                            cursor: pointer;
                        }
                    }
                    .pre-validation-content,
                    .operators-validation {
                        position: relative;
                        height: calc(100vh - 160px);
                    }

                    .pre-validation-content {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        .sims-inputs-box {
                            display: flex;
                            padding: 0 20px;
                            .keyboard-input {
                                max-width: 50%;
                                flex-grow: 1;
                                padding: 20px;
                                margin-right: 20px;
                                border: 1px solid #C9CFD4;
                                -webkit-border-radius: 5px;
                                -moz-border-radius: 5px;
                                border-radius: 5px;

                                .instruction {
                                    margin: 0 0 12px;
                                }

                                .add-sims-container {
                                    display: flex;
                                    margin: 0 auto;

                                    .btn-scan{
                                        width: 110px;
                                        height: 35px;
                                        background-color: #00b1ff;
                                        -webkit-border-radius: 5px;
                                        -moz-border-radius: 5px;
                                        border-radius: 5px;
                                        border: none;
                                        color: #EDEEEF;
                                        padding: 8px 16px;
                                        margin-right: 20px;
                                    }

                                    .add-sims {
                                        display: flex;
                                        width: 100%;

                                        input {
                                            flex-grow: 1;
                                            border: 1px solid #d2d8db;
                                            -webkit-border-radius: 5px;
                                            -moz-border-radius: 5px;
                                            border-radius: 5px;
                                            border-top-right-radius: 0;
                                            border-bottom-right-radius: 0;
                                            padding: 8px;
                                        }

                                        .btn-add {
                                            min-width: 95px;
                                            border: 1px solid #55cd6c;
                                            -webkit-border-radius: 5px;
                                            -moz-border-radius: 5px;
                                            border-radius: 5px;
                                            border-top-left-radius: 0;
                                            border-bottom-left-radius: 0;
                                            background-color: #55cd6c;
                                            padding: 8px 16px;
                                            color: #EDEEEF;
                                        }
                                    }
                                }
                            }

                            .dnd-sims {
                                max-width: 50%;
                                flex-grow: 1;
                                border: 2px dashed #2f353a;
                                position: relative;
                                overflow: hidden;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                padding: 0 20px;

                                &.dragged-fiel {
                                    background-color: #b2dbff;
                                    .spacer-wrap .spacer span {
                                        background-color: #b2dbff;
                                    }
                                }

                                .innersims {
                                    display: flex;
                                    align-items: center;
                                    img {
                                        height: 50px;
                                        width: auto;
                                        margin-right: 10px;
                                    }
                                    .dnd-text {
                                        flex-grow: 1;
                                        h3 {
                                            margin: 0 0 8px;
                                            font-size: 12px;
                                        }
                                        p {
                                            margin: 0;
                                            font-size: 12px;
                                            color: #c8caca;
                                        }
                                    }
                                    .btn-primary {
                                        margin: 0 0 0 20px;
                                        background-color: #00b1ff;
                                    }
                                    input[type="file"] {
                                        position: absolute;
                                        top: -200px;
                                        left: -200px;
                                    }
                                }

                                h3 {
                                    margin-top: 30px;
                                    font-size: 13px;
                                    line-height: 18px;
                                }

                                .spacer-wrap {
                                    text-align: center;
                                    padding-bottom: 30px;

                                    .spacer {
                                        max-width: 150px;
                                        margin: auto;
                                        position: relative;

                                        &::after {
                                            content: '';
                                            display: block;
                                            height: 1px;
                                            width: 100%;
                                            background-color: #EDEEEF;
                                            position: absolute;
                                            top: 12px;
                                            z-index: 2030;
                                        }

                                        span {
                                            background-color: #fff;
                                            padding: 0 10px;
                                            position: absolute;
                                            left: 0;
                                            z-index: 2040;
                                            right: 0;
                                            max-width: 40px;
                                            margin: auto;
                                        }
                                    }
                                }
                            }
                        }

                        .control-bar {
                            display: flex;
                            justify-content: flex-end;
                            background-color: #f0f3f5;
                            padding: 20px;

                            .btn-light,
                            .btn-success {
                                margin-left: 10px;
                            }
                        }
                        .add-sim-dialog {
                            height: 21px;
                            margin: 0;
                            color: #d10505;
                        }
                        .list-sims {
                            height: calc(98.5vh - 566px);
                            padding: 20px;
                            overflow: auto;
                            ul {
                                li {
                                    width: 12.5%;
                                    &.validate-none {
                                        .fts-icon-sim:before {
                                            color: #515b65;
                                        }
                                    }
                                }
                            }
                        }
                        .list-sims-higher {
                            height: calc(98.5vh - 566px);
                        }
                        .uploaded-sims {
                            position: relative;
                            flex-grow: 1;
                            display: flex;
                            flex-direction: column;
                            margin: 20px 0 0;
                            padding: 0 20px 20px;
                            overflow: auto;

                            .invalid-sims {
                                padding: 20px;
                                -webkit-border-radius: 5px;
                                -moz-border-radius: 5px;
                                border-radius: 5px;
                                border: 1px solid #FC4D4D;
                                background-color: #FFE3E3;
                                .invalid-sims-list-header {
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    .left-side {
                                        h3 {
                                            margin: 0 0 6px;
                                            font-size: 15px;
                                            font-weight: 700;
                                        }
                                        h4 {
                                            font-size: 12px;
                                            margin: 0;
                                            font-weight: 400;
                                        }
                                    }
                                    .right-side {
                                        i {
                                            font-size: 24px;
                                            color: #0088ff;
                                            cursor: pointer;
                                        }
                                    }
                                }
                                .invalid-sims-list {
                                    display: none;
                                    margin: 24px 0 0 0;

                                    &.expanded {
                                        display: block;
                                    }

                                    &:first-child {
                                        margin: 32px 0 0 0;
                                    }

                                    .name {
                                        margin: 0 0 6px;
                                        font-size: 14px;
                                        font-weight: 700;
                                    }
                                    .desc {
                                        margin: 0 0 12px;
                                        font-size: 12px;
                                        font-weight: 400;
                                    }
                                    .list-of-sims {
                                        display: flex;
                                        flex-wrap: wrap;
                                        .sim {
                                            margin: 0 50px 12px 0;
                                            .fts-icon-sim {
                                                &:before {
                                                    color: #515b65;
                                                }
                                            }
                                        }
                                    }

                                }
                            }

                            .valid-sims {
                                margin: 20px 0 0;
                                .valid-sims-header {
                                    margin: 0 0 12px;
                                    font-size: 15px;
                                    font-weight: 700;
                                }
                                .valid-sims-list {
                                    display: flex;
                                    flex-wrap: wrap;

                                    .sim {
                                        margin: 0 50px 12px 0;
                                        color: #00b406;
                                        .fts-icon-sim {
                                            margin-right: 4px;
                                            &:before {
                                                color: #00b406;
                                            }
                                        }

                                        .fa-close {
                                            margin-left: 4px;
                                            cursor: pointer;
                                        }
                                    }
                                }
                            }
                        }
                        .validated-sims {
                            background-color: #55cd6c;
                            color: #EDEEEF;
                            display: flex;
                            justify-content: center;
                            padding-top: 24px;
                            padding-bottom: 24px;
                            font-size: 18px;
                            .check-icon {
                                margin-right: 20px;
                                &:before {
                                    content: "\f00c";
                                    font-family: FontAwesome;
                                    font-style: normal;
                                    font-size: 18px;
                                }
                            }
                            &.failed {
                                background-color: #FC4D4C;
                                .check-icon {
                                    &:before {
                                        content: "\f00d";
                                        font-family: FontAwesome;
                                    }
                                }
                            }
                        }
                        .validated-sims-padding {
                            height: 70px;
                        }
                    }

                    .operators-validation {
                        flex-grow: 1;
                        display: flex;
                        flex-direction: column;
                        overflow: auto;
                        .operators-validation-header-box {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            .btn-danger {
                                margin: 20px 20px 0 0;
                            }
                        }
                        @media (max-width: 450px) {
                            .operators-validation-header-box {
                                flex-direction: column;
                                align-items: flex-start;
                                .btn-danger {
                                    margin: 0 0 12px 20px;
                                }
                            }
                        }
                        .operators-validation-header {
                            margin: 20px 20px 12px;
                            font-size: 15px;
                            font-weight: 700;
                        }
                        .operators-validation-list {
                            display: flex;
                            flex-wrap: wrap;
                            padding: 0 20px;
                            overflow: visible;
                            .sim {
                                position: relative;
                                margin: 0 50px 12px 0;
                                .sim-message {
                                    display: none;
                                    position: absolute;
                                    bottom: calc(100% + 10px);
                                    left: 0;
                                    min-width: 250px;
                                    text-align: center;
                                    padding: 8px 16px;
                                    -webkit-border-radius: 5px;
                                    -moz-border-radius: 5px;
                                    border-radius: 5px;
                                    background-color: #191919;
                                    color: #fff;
                                    z-index: 1;
                                }
                                &:hover {
                                    .sim-message {
                                        display: inline;
                                    }
                                }
                                .fts-icon-sim {
                                    margin-right: 4px;
                                }
                                .fa-close {
                                    margin-left: 4px;
                                    cursor: pointer;
                                }
                                &.validation-passed {
                                    color: #55cd6c;
                                    .fts-icon-sim {
                                        &:before {
                                            color: #55cd6c;
                                        }
                                    }
                                }
                                &.validation-failed {
                                    color: #FC4D4C;
                                    .fts-icon-sim {
                                        &:before {
                                            color: #FC4D4C;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .control-bar {
                    .left-side {
                        .btn {
                            margin-right: 10px;
                            &:last-child {
                                margin-right: 0;
                            }
                        }
                    }
                }
            }
        }
    }

    .dark-theme {
        .wrapper-modal-add-to-cold-stock {
            .modal-body {
                .modal-inner {
                    border-color: #2f353a;
                    background-color: #3a4149;

                    .content-modal {
                        color: #edeeef;

                        .pre-validation-content,
                        .operators-validation {
                            .loading-sims {
                                background-color: rgba(47, 53, 58, 0.7);
                            }
                        }

                        .pre-validation-content {
                            .sims-inputs-box {
                                .keyboard-input {
                                    border-color: #1a1c1d;
                                    .add-sims-container {
                                        input {
                                            border-color: #1a1c1d;
                                        }
                                    }
                                }
                            }
                            .uploaded-sims {
                                .invalid-sims {
                                    color: #fff;
                                    background-color: #6B3D3D;
                                    border-color: #FC4D4D;
                                    .invalid-sims-list-header {
                                        .right-side {
                                            i {
                                                &:before {
                                                    color: #fff;
                                                }
                                            }
                                        }
                                    }
                                    .invalid-sims-list {
                                        .sim {
                                            .fts-icon-sim {
                                                &:before {
                                                    color: #fff;
                                                }
                                            }
                                        }
                                    }
                                }
                                .valid-sims {
                                    .valid-sims-list {
                                        .sim {
                                            color: #55CD6C;
                                            .fts-icon-sim {
                                                &:before {
                                                    color: #55CD6C;
                                                }
                                            }
                                            .fa-close {
                                                &:before {
                                                    color: #55CD6C;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            .control-bar {
                                border-color: #1a1c1d;
                            }
                        }

                        .control-bar {
                            background-color: #2f353a;
                        }

                        .dnd-sims {
                            border-color: #edeeef;
                        }

                        .add-sims-container {
                            .add-sims {
                                input {
                                    background-color: #515b65;
                                    border-color: #2f353a;
                                    color: #edeeef;

                                    &::placeholder {
                                        color: #dcdcdc;
                                    }
                                }
                            }
                        }

                        .operators-validation {
                            .operators-validation-list {
                                .sim {
                                    &.validation-passed {
                                        .fa-close {
                                            &:before {
                                                color: #55cd6c;
                                            }
                                        }
                                    }
                                    &.validation-failed {
                                        .fa-close {
                                            &:before {
                                                color: #fc4d4c;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .wrong-sims,
    .right-sims {
        margin-bottom: 20px;
        h4 {
            display: block;
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: 700;
        }
    }

    .right-sims {
        .validate-false {
            display: none;
        }
    }
</style>
